// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pm_a bhp_ea bhp_ke bhp_ju bhp_a bhp_j bhp_so bhp_sp","SearchPanel__icon":"pm_b bhp_vo bhp_hi bhp_su bhp_va","SearchPanel__input":"pm_c bhp_jb bhp_eg bhp_z"};